/*
ABOUT >>
THIS INPUT USED FOR MAKE GRIDS IN ADD AND EDIT POPUP
FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE AND WHEN LOAD THEN NOT PASSING VALUES OR FUNCTIONS TO PARENT 
*/
import React, { useEffect,  useRef, useState, useMemo } from 'react';
import './dynamic-v-3.scss';
import DialogInput from './list-button-popup-list-v-3';

import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
  endEdit,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import HardDelete from '../hard-delete/hard-delete';
import AuditTableInput from '../audit-table/audit-table'
import SecureComponent from '../security/secure.component';
import SecurityService from '../security/security.service';
import IrtizDynamicInputAdd from './mainSection-popup-add-v-3';
// import { useDispatch, useSelector } from 'react-redux';
// import { gridColumnsList } from '../../store/slices/list-tempate';
import moment from 'moment';
// import accessoryBOMService from './irtiza-dynamic-input.service';
import { AutoComplete, AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import DropdownService from './api.service-v-3';
import { NumericTextBox , } from "@syncfusion/ej2-inputs";
import { CheckBox } from '@syncfusion/ej2-react-buttons';

import  imgSrc from './spinner.gif';
import { Undo } from '@material-ui/icons';
import { boolean } from 'yup';




// let irtizaDynamicGrid: Grid;

let selectedRows = []
let selectedRowIndex = undefined;
let dataListData =[]

export default function AccessoryBOMList(
  {
  Id='Dynamic',
  ListTitle = '',
  ColumnsList = [],
  GridDataSource = [],
  DefaultSortedColumnName='',
  GridDialog = [],
  ListActionComplete,
  ToolbarClicking = undefined,
  SelectRowByID = undefined,
  
  // OPTIONAL
  ListDelete=[],
  DeleteType='Hard',
  AllowTemplate=false,
  ToolbarOption= 'All',
  AllowGrouping=true,
  AllowExcelExport=true,
  AllowPdfExport=true,
  ShowColumnChooser=true,
  AllowPaging=true,
  AllowFiltering=true,
  AllowDataBound=false,
  ListSecurity='',
  AddSecurity='',
  EditSecurity='',
  DeleteSecurity='',
  DefaultSortedColumnSort='Descending',
  FilterColumns=[],
  GroupColumns=[],
  GridEditSettingHeaderTemplate='<p></p>',
  GridEditSettingMode='Dialog',
  GridSumColumns=[],
  AllowGridSum=false,
  FooterSumCaption=[],
  // ListService,
  RegisterChildFunction ,
  PrintedByUserName='',
  rowDataBound=undefined,
  EditActionCompleteType='Edit',
props
 }) {

// const grids = use/Ref({});
const grids = useRef({});
// const getGridInstance = (id) => grids.current[id];
// const grids.current[Id] = getGridInstance(Id)

  // const formatOptions = { type: 'date', format: 'dd/MM/yy' }
  const formatOptions = { type: 'date', format: 'dd-MMM-yy' }

  function addUnderscore(input) {
    return input.replace(/([a-z])([A-Z])/g, '$1_$2');
}
  // InvoiceEvaluationID	
  // InvoiceNo	
  // MainInvoiceID	
  // CurrencyName	
  // CurrencyID	
  // ExchangeRate	
  // HawalaCommissionPercent	
  // CurrencyNameHawala	
  // CurrencyIDHawala	
  // AccountTitleHawalaDr	
  // AccountIDHawalaDr	
  // AccountTitleHawalaCr	
  // AccountIDHawalaCr
//   ColumnsList.forEach(column => {
//     if (column.field.endsWith('Date')) {
//         column.other.push({ 'format': formatOptions });
//     }
// });
//
// if(ColumnsList.length > 0){
  
  
//   ColumnsList = [...ColumnsList];
  
//   let dateIndex = ColumnsList.findIndex(res => res.field.endsWith('Date'));
//   if (dateIndex !== -1) {
//     ColumnsList[dateIndex].other = [ { 'format': formatOptions }]
//     }
//     }
//   var ColumnProps =  ColumnsList

// let Columns = [...ColumnsList];


//       var ColumnProps =  ColumnsList
      // if (column.field.endsWith('Date')) {
      //     column.other.push({ 'format': formatOptions });
      // }
    

  
  // InputL ist Security Name
//   let InputListSecurity = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'AccessoryBOMList' : 'AccessoryBOMDetailList';
// let defaultSortColumnName = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'AccessoryBOMID' : 'AccessoryBOMDetailID'
// let defaultSortColumnType =  'Descending'
// let InputNameForPdfExcelExport = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'Accessory BOM - LIST' : 'Accessory BOM DETAIL - LIST'
// let exportFileName = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'accessory_bom' : 'accessory_bom_detail'
let InputListSecurity = ListSecurity == '' ? `${Id}List`:ListSecurity;
let defaultSortColumnName = DefaultSortedColumnName
let defaultSortColumnType =  DefaultSortedColumnSort 
let InputNameForPdfExcelExport = ListTitle
let exportFileName = addUnderscore(Id)

 //  DYNAMIC CODE 
//  const dispatch = useDispatch()
//  const ColumnProps = useSelector(state =>{return state.listTemplate})

 var filterColumnName = []
 var recordColumnName = []
 var fiterCheckedValue = []
  // const [dataSourceState, setDataSourceState] = useState([]);
  const [dataSourceStates, setDataSourceStates] = useState([]);
  const [loadingdataSourceState, setLoadingDataSourceState] = useState(false);

  const [filterState, setFilterState] = useState([]);
  
  const [groupState, setGroupState] = useState([]);
  
  const [deletingProps, setDeletingProps] = useState();
  const [showDialogs, setShowDialogs] = useState(false);

  const [selectedRow, setSelectedRow] = useState([]);


  // useEffect(()=>{
  //   if(dataSourceStates.length > 0){
  //     console.log(dataSourceStates)
  //     setDataSourceState([])
  //     grids.current[Id].refresh()
  //     setDataSourceState(dataSourceStates)
  //     setDataSourceStates([])
  //   }

  // },[dataSourceStates.length > 0])
  const [dataSourceState, setDataSourceState] = useState({});

  // Save data for the specific Id
  // const saveData = (newData , type = 'replace') => {
  //   console.log(newData)
  //   console.log(updatedData)
  //   if(type == 'replace'){
  //     const updatedData = newData.map((item, index) => ({
  //       ...item,
  //       IdentityField: index + 1, // starts from 1
  //     }));
  //   setDataSourceState(prevState => ({
  //     ...prevState,
  //     [Id]: [...updatedData],  // Append new data to existing data for the Id
  //   }));
  // }else if(type == 'push'){
  //   setDataSourceState(prevState => ({
  //     ...prevState,
  //     [Id]: DefaultSortedColumnSort == "Descending"
  //       ? [...(prevState[Id] || []), ...updatedData]  // Add at the end
  //       : [...updatedData, ...(prevState[Id] || [])]  // Add at the start
        
  //   }));
    
  // }
  // };
// console.log('laiba')
  const saveData = (newData, type = 'replace') => {
    console.log(newData)
    setDataSourceState(prevState => {
      const existingData = prevState[Id] || [];
  
      let updatedData = [];
  
      if (type === 'replace') {
        // For replace, identity starts from 1
        updatedData = newData.map((item, index) => ({
          ...item,
          IdentityField: index + 1,
        }));
  
        return {
          ...prevState,
          [Id]: [...updatedData],
        };
      } else if (type === 'push') {
        // For push, continue identity from existing data
        const startIndex = existingData.length;
  
        updatedData = newData.map((item, index) => ({
          ...item,
          IdentityField: startIndex + index + 1,
        }));
  
        return {
          ...prevState,
          [Id]: DefaultSortedColumnSort === "Descending"
            ? [...existingData, ...updatedData]  // Add at the end
            : [...updatedData, ...existingData], // Add at the start
        };
      }
  
      return prevState; // fallback
    });
  };
  
  useEffect(() => {
    // Initialize with empty array if data for Id doesn't exist
    if (Id && !dataSourceState[Id]) {
      setDataSourceState(prevState => ({
        ...prevState,
        [Id]: []
      }));
    }
  }, [Id]);

  const handleProductCutSizeBlur = (inputID, inputObj, gridAddNewClicked , id) => {
    if (inputID === undefined || inputObj.element.value === null || inputObj.element.value === '' ) {
      if( document.getElementById(id)){
      document.getElementById(id).parentElement.style.border = '3px solid red';
      setTimeout(() => {
        if(document.getElementById(id)){
        document.getElementById(id).parentElement.style.border = '1px solid #c8c8c8';
        }
      }, 1000)
    }
      if (gridAddNewClicked === false) {
        inputObj.element.focus();
      }
    }
  };
 
  const handleInputFocus = (inputRef ,isGrid) => {
    // Access the AutoCompleteComponent instance and open the dropdown
    if (isGrid == true ) {
    if (inputRef ) {
        inputRef.showPopup();
    }
  }
  else{
      if (inputRef ) {
          inputRef.current.showPopup();
      }

    }
};

const getDataSource = async (type,filter ,obj)=>{
  try {
    const response = await DropdownService.getAllForList(type);
    if (response.data && response.data.recordset) {
            if(filter != {}){

            }else{
            }
            obj.dataSource = response.data.recordset;
              
    }
      else {
      console.error("Invalid response structure:", response);
    }
   } catch (error) {
    }
}

// var saleProductNameDataSource = []
// let saleProduct = useRef(null)
// const [saleProductNameDataSource, setSaleProductNameDataSource] = useState([]);
// const getSaleProductNameDataSource =  async (id)=>{
//   try {
//     let response =  await invoiceService.getMultiDropDownSource(`Stock ,0, 01-JUN-24 ,  ${moment().format('DD-MMM-YY')},${id}`)
//       if(response.data  && response.data.recordset){
//         console.log(response.data.recordset)
//         console.log(saleProduct)
//         // setSaleProductNameDataSource(response.data.recordset);
//         // saleProductNameDataSource = response.data.recordset;
//         saleProduct.current.dataSource = response.data.recordset
//       }
    
//   } catch (error) {
//     console.log(error)
//   }  
// }

let checkboxInstances ={}
const createCheckbox = (params) => {
  console.log(params)
  let obj;
  let Elem;

  const create = () => {
    Elem = document.createElement('input');
    Elem.type = 'checkbox';
    return Elem;
  };

  const destroy = () => {
    if (obj) {
      obj.destroy?.(); // If you use Syncfusion CheckBox component
    }
  };

  const read = () => {
    return obj?.checked;
  };

  const write = (args) => {
    
    const dynamicKey = `checkbox_${params.field}`;
    // Create Syncfusion Checkbox instance (or native one if needed)
    obj = new CheckBox({
      label: params.caption || '',
      checked: args.rowData[params.field] ||  params.checked == true ? true : false,
      created:(e)=>{
        console.log(e);
        console.log(params)
        // checkboxInstances[dynamicKey].element.checked = args.rowData[params.field] ? args.rowData[params.field] : (params.checked == 'true' ? true : false);
      },
      change: (e) => {
        args.rowData[params.field] = e.checked;

        if (params?.onChange) {
          params.onChange(e.checked, args, dynamicKey);
        }
      },
      cssClass: "GridCheckbox",
      name:params.field
    });
    checkboxInstances[dynamicKey] = obj;
    obj.appendTo(Elem);
  };

  return { create, destroy, read, write };
};

var autoCompleteInstances = {};
  const createAutoComplete = (params) => {
    console.log(params)
    let obj : AutoComplete;
      let Elem : HTMLElement;
    const create = () => {
       Elem = document.createElement(`input`);
      return Elem;
    }
    const destroy = () => {
      obj?.destroy();
    }
    const read = () => {
      return obj?.text;
    }
     // Store instances here
    
    const write = (args) => {
      let dynamicKey = `obj_${params.field.id}`; // Create a dynamic key
       autoCompleteInstances[dynamicKey]  = new AutoComplete({
        created:async ()=>{
          console.log(params)
          console.log(args)
          if(args.requestType == "beginEdit"){
              let idColumn = params.field.id;
              
              let valueColumn = params.field.value;

              autoCompleteInstances[dynamicKey].dropdownValues =  {[idColumn]: args.rowData[idColumn] ,  [valueColumn]: args.rowData[valueColumn]}

          }
          if(params?.source?.type == 'Route'){
            await getDataSource(params.source.dataSource , params.filter, autoCompleteInstances[dynamicKey]  )
            console.log(autoCompleteInstances[dynamicKey].dataSource)
        }else if(params?.source?.type == 'Data'){
          autoCompleteInstances[dynamicKey].dataSource = params?.source?.dataSource
        }
        },
        focus:()=>{
          console.log(args)
          console.log(params)
            let idColumn = params.field.id;
              
              let valueColumn = params.field.value;

              autoCompleteInstances[dynamicKey].dropdownValues =  {[idColumn]: args.rowData[idColumn] ,  [valueColumn]: args.rowData[valueColumn]}

          document.getElementById(`${Id}Grid${params.field.value}`).select()
          handleInputFocus(args.element.ej2_instances[0],true)},
        select: async (e) => {
          //     if(params.field.id == 'BrandID'){
          //  await getSaleProductNameDataSource(e?.itemData.id)

          //     }
          if(params.onSelect){ params.onSelect({
            ...e?.itemData,
            id:e?.itemData?.id ? e?.itemData?.id : undefined,
            value:e?.itemData?.value ? e?.itemData?.value : '' 
          
        }, params.field.value , args,autoCompleteInstances)
      }

          autoCompleteInstances[dynamicKey].dropdownValues =  {...e.itemData, [params.field.id]: e.itemData.id ,  [params.field.value]: e.itemData.value}
          args.rowData[params.field.id] = e.itemData.id;
          args.rowData[params.field.value] = e.itemData.value;

          if(params.select && params.select.source){
            if(params.select.source.type == 'Function'){
              let paramsArray = params.select.source.dataSource.params;
              const generateParams = paramsArray.map((res)=>{
                if(res.type == 'Column'){
                  return args.rowData[res.source]
                }else{
                  return res.source
                }
              })
              
              const response = await params.select.source.dataSource.function(generateParams.join(','))
              console.log(response)
                if(response.data && response.data.recordset){
                  autoCompleteInstances[`obj_${params.select.source.dataSource.dropDownKey}`].dataSource = response.data.recordset;
                }
            }else{

            }
          
          }
        },
        change: (e) => {
          const autoCompleteInstance = args.element.ej2_instances[0];
          
          const isValid = autoCompleteInstance.dataSource.some(s => s.value === e.value);
          if (!isValid) {
            args.rowData[params.field.id] = 0;
            args.rowData[params.field.value] = e.value;
          } else {
            const selectedItem = autoCompleteInstance.dataSource.find(s => s.value === e.value);
            autoCompleteInstances[dynamicKey].dropdownValues =  {...e.itemData , [params.field.id]: e.itemData.id ,  [params.field.value]: e.itemData.value}
            args.rowData[params.field.id] = selectedItem.id;
            args.rowData[params.field.value] = selectedItem.value;

          }
        },
        blur: () => {
      
          const id = `${Id}Grid${params.field.value}`;
          handleProductCutSizeBlur(args.rowData[params.field.id],  autoCompleteInstances[dynamicKey] , false, id);
        },
       
        // Helper function to render rows
       
        // i/
        value: args.rowData[params.field.value],
        fields: { value: "value" },
        floatLabelType: "Never",
        placeholder: `Select ${params.caption}`,
        highlight: true,
        cssClass: "GridDropdown",
        showClearButton: false,
        
      });
         autoCompleteInstances[dynamicKey]?.appendTo(Elem);
    }
    return { create, destroy, read, write };
  }


  let numericInstances = {};

const createNumericInput = (params,headerText) => {
  let obj :NumericTextBox;
  let Elem : HTMLElement;

  const create = () => {
    Elem = document.createElement(`input`);
    return Elem;
  };

  const destroy = () => {
    obj?.destroy();
  };

  const read = () => {
    return obj?.value;
  };

  const write = (args) => {
    
    let dynamicKey = `obj_${params.field}`; // Create a dynamic key

    numericInstances[dynamicKey] = new NumericTextBox({
      value: args.rowData[params.field],
      
      placeholder: `Enter ${params?.caption || headerText} `,
      floatLabelType: "Never",
      
      cssClass: "GridNumericInput",
      min: params?.min || 0,
      
      max: params?.max || 9999999999999999999999999,
      // decimals:3,
      step: params?.step || 1,
      format: params?.format || "n0", // Default to 2 decimal places
      change: (e) => {
        args.rowData[params.field] = e.value;
        // args.rowData[params.field] = e.value;
        if(params.onChange){ params.onChange({
          value:e.value
        
      }, params?.field , args,numericInstances)
    }
      },
      blur: () => {
        // const id = `${Id}Grid${params.field.value}`;
        // handleProductCutSizeBlur(args.rowData[params.field.id], numericInstances[dynamicKey], false, id);
      },
    });

    numericInstances[dynamicKey]?.appendTo(Elem);
  };

  return { create, destroy, read, write };
};






































    const ddlFields: object = { value: 'value' };
  
  // const CreateAutoCompleteComponent =(params) =>{
  //   console.log(params);
  
  // // Assign a dynamic ref based on the name prop
  
  //   let dynamicKey = `obj_${params.field.id}`; // Create a dynamic key

  //   // const autoCompleteData = autoCompleteInstances[dynamicKey] || { dataSource: [], caption: '' };
  //   // autoCompleteInstances[dynamicKey] = {
  //   //   caption:params.caption,
  //   //   dataSource:[]
  //   // }
  //   const ddlFields: object = { value: 'value' };
  // //  console.log(autoCompleteInstances)
    
  //   return(
      // <>
      // <AutoCompleteComponent 
      // dataSource={params.dataSource}
      // fields={ddlFields}
      // floatLabelType='Auto' 
      // highlight={true}
      // />
      // </>
  //   )
  // }
    // const CreateMultiDropDown = useMemo(() => (props) => {
  //   console.log(props);
  //   console.log(autoCompleteInstances); // Assuming autoCompleteInstances is defined elsewhere
  //   return (
  //     <>
  //       <div>
  //         {/* Displaying a placeholder text based on your example */}
  //         irtiza 
  //       </div>
  //     </>
  //   );
  // }, [autoCompleteInstances]);

  var ColumnProps =   []
  useEffect(() => {
    // grids.current[Id]?.dataBound(grids.current[Id]?.autoFitColumns()) ;
    const transformedFilters = FilterColumns.map(col => ({
      field: col.field,
      operator: col.operator ? col.operator : 'equal',
      value: col.value.toString() // Ensure the value is a string
  }));
  setFilterState(transformedFilters);

//   ColumnProps = ColumnsList.map(column => {
//       if (column.field.endsWith('Date')) {
//           return {
//               ...column,
//               other: [{  'format': formatOptions , ...column.other[0] }]
//           };
//       }else if(column.field.startsWith('Is') && column.field != 'IsDeleted' && column.field != 'IsApproved') {
//         return {
//           ...column,
//           other: [{...column.other[0],  template:(props) => {
//             return (
//             <p style={{margin: '0px'}}>{props[column.field] == true ? 'Yes' : 'No'}</p>
//             )
//             }   }]
//       };
//       }else if(column.field == 'CompanyName') {
//         return {
//           ...column,
//           other: [{...column.other[0],  edit:createAutoComplete({caption:'Company'  , field:{id:'CompanyIDCustomer',value:'CompanyName'}}) }]
            
//       }
//       }else if(column.field == 'AccountTitleHawalaDr') {
//         return {
//           ...column,
//           other: [{...column.other[0],  edit:createAutoComplete({caption:'Company'  , field:{id:'AccountTitleHawalaID',value:'AccountTitleHawalaDr'}}) }]
            
//       }
//     }
//       return column;
//   });
 
    // dispatch(gridColumnsList(updatedColumns))
    setGroupState(GroupColumns)
    getListService();
    
    // setTimeout(() => {
    //   grids.current[Id].selectRow(0)
    // }, 5000);
  // }, []);

  
  }, [GridDataSource[0]?.DataSource]);
  useEffect(()=>{
    setTimeout(() => { 
      // Ref(getListService)
      // ListService(getListService)
      
     
      if(SelectRowByID != undefined && grids.current[Id]?.currentViewData.length > 0){ grids.current[Id].selectRow(SelectRowByID)}
  
    }, 100);
  },[SelectRowByID])
  // }, [GridDataSource[0].DataSourceType]); 
// DYNAMIC TEMPLATE CODE
const [isToggled, setIsToggled] = useState(false);
const [ToggledValue, setToggledValue] = useState( 'Hide Template');
useEffect(() => {
  setTimeout(() => {
    setToggledValue(isToggled == true? 'Hide Template' : 'Show Template')
  }, 100);  
}, [isToggled]);

    // let dialogInstance: DialogComponent;
    // const toolbar: ToolbarItems[] = ['PDFExport'];
  const toolbarClick = (args: ClickEventArgs) => {
    let reportName = document.getElementById('reportName')?.value;
    let getOrientation = document.getElementsByClassName('orientation')
    let selectedOrientation = getOrientation[0]?.checked ==  true ? 'Portrait':'Landscape';
    let getHeaderCheck = document.getElementsByClassName('headerCheck')[0]?.checked;
    let headerCheck =  !getHeaderCheck
    if ( grids.current[Id] && args.item.properties.id === `${Id}Grid_PDFExport` ) {
      if(headerCheck == true){
        let ress = filterColumnName.map((res, index) => {
          // Convert camelCase to Title Case and uppercase all letters
          let title = res.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase();
          // Calculate position dynamically
          let position = { x: 10, y: 120 + (index * 40) };
          // Define style properties
          let style = { textBrushColor: "#000000", fontSize: 12, hAlign: 'Center' };
          // Join checked values with separator '|'
          let checkedValues = fiterCheckedValue[index].join(' | ');
          
          return {
              position: position,
              style: style,
              type: "Text",
              value: `${title}: ${checkedValues},`
          };
      });
      
  const exportProperties: PdfExportProperties = {
          header: { 
          contents: [ 
            // {
            //   position: { x: 10, y: 30 },
            //   size: { width: 120, height: 80 }, // Set the width and height of the image
            //   type: "Image",
            //   src:''
            // },
            { 
              position: { x:selectedOrientation == 'Landscape' ?420:260 , y: 50 }, 
              style: { textBrushColor: "#000000", fontSize: 20, hAlign:'Center' }, 
              type: "Text", 
              value: `DALAL INDUSTRIES`
              
            },
            { 
              position: { x:selectedOrientation == 'Landscape' ?410:270 , y: 80 }, 
              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
              type: "Text", 
              value: reportName.toUpperCase() ? reportName.toUpperCase() : InputNameForPdfExcelExport
              },  
            ...ress
          
          ]
           ,
           fromTop: 0, 
            height: 230 
        },
         footer: {
                    contents: [
                        {
                            format: 'Page {$current} of {$total}',
                            pageNumberType: 'Northwind Traders',
                            position: { x: selectedOrientation == 'Landscape' ?930:600, y: 25 },
                            style: {
                                fontSize: 16,
                                textBrushColor: '#000000'
                              },
                              type: 'PageNumber'
                            },
                            { 
                              position: { x:selectedOrientation == 'Landscape' ?20:10 , y: 25 }, 
                              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
                              type: "Text", 
                              value: `DATE: ${ moment().format('DD-MM-YYYY HH:mm:ss')}`
                            },
                            { 
                              position: { x:selectedOrientation == 'Landscape' ?420:320 , y: 25 }, 
                              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
                              type: "Text", 
                              value: `Printed By: ${PrintedByUserName}`
                              }
                          ],
                          fromBottom: 20,
                          height: 60
                },
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.pdf`
      };
      setTimeout(() => {
        
        return grids.current[Id].pdfExport(exportProperties); 
      }, 500);
}else{
  const withOutHeaderexportProperties: PdfExportProperties = {
    pageOrientation: selectedOrientation,
    fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.pdf`
  };
  grids.current[Id].pdfExport(withOutHeaderexportProperties);
}
    
    }
    if (
      grids.current[Id] &&
      args.item.properties.id === `${Id}Grid_excelexport`
    ) {
      if(headerCheck == true){
      let excelress =   filterColumnName.map((res,ind)=>{
        let title = res.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase()
        // let len = fiterCheckedValue.length()
       return { cells: [{ colSpan: 6, value: `${ title} :  ${fiterCheckedValue[ind].join(',')}` , style: {  fontSize: 12,hAlign: 'Left', }} ]}
      
      })
      const exportProperties: ExcelExportProperties = {
        
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.xlsx`,
        footer: {
          footerRows: 2,
          rows: [
              { cells: [{ colSpan: 4, value: `Printed By: ${PrintedByUserName}`, style: { hAlign: 'Center', bold: true } }] },
              
          ]
      },
      header: {
          headerRows: 4 + fiterCheckedValue.length,
          rows: [
              { cells: [{ colSpan: 2, value: "", style: {  fontSize: 20, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value: "DALAL INDUSTRIES", style: {  fontSize: 25, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value:reportName.toUpperCase() ? reportName.toUpperCase():'PRODUCT FINISH SIZE - LIST', style: { fontSize: 15, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value: `DATE: ${ moment().format('DD-MM-YYYY HH:mm:ss')}` , style: {  fontSize: 12,hAlign: 'Right' } }] },
              ...excelress
          ]
      },

      };
      grids.current[Id].excelExport(exportProperties);
     }else{
      const exportProperties: PdfExportProperties = {
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.xlsx`
      };
      grids.current[Id].excelExport(exportProperties);
    }
    }
    if (
      grids.current[Id] &&
      args.item.properties.id === `${Id}Grid_columnchooser`
    ) {
    }
    if (grids.current[Id] && args.item.properties.id === 'Delete' ) {
      if (selectedRows.length === 0) {
        // no rows selected
        // setDialogWarningVisibility(false);
        let obj={
          RowID:undefined,
          SelectedRow:false
          
        }
        setDeletingProps(obj)
        setShowDialogs(true)

      } else {
        if(ListDelete.length == 0){
          let GridObj = {...selectedRows};
        for (let key in GridObj) {
          if (GridObj.hasOwnProperty(key)) {
            const dateKeys = ['ApprovedByDate', 'CreationDate', 'UpdationDate', 'DeletionDate'];
            const booleanKeys = ['IsDeleted', 'IsClosed', 'IsApproved'];
            if(key.endsWith('ID') || key.includes('ID') || booleanKeys.includes(key) || dateKeys.includes(key) ){
              delete GridObj[key]
            }else{
              if(key.includes('Date')){
                if(GridObj[key] instanceof Date){
                  GridObj[key] = moment(GridObj[key]).format('DD-MMM-YY')
                }
              }else if(key.includes('Rate')){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(2)
              
              }else if(!isNaN( GridObj[key])){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(1)
              }else{
                GridObj[key] = GridObj[key]
              }

            }
          }
          
        }
        // deleteDialog.current.hide();
        console.log(selectedRows)

        let obj={
          TableName:Id,
          ColumnName:DefaultSortedColumnName,
          // DeleteSecurity:ListDelete[0]?.DeleteSecurity ?  ListDelete[0].DeleteSecurity : undefined,
          RowID:selectedRows[DefaultSortedColumnName],
          SelectedRow:true,
          UserID:userId,
          IdentityField:selectedRows['IdentityField']
          // SelectedRowData:GridObj
            }
            if(DeleteType == 'Soft'){
              obj.DeleteSecurity = `${Id}Delete`
              }
          setDeletingProps(obj)
        setShowDialogs(true)
        }else{
        
        let GridObj = {...selectedRows};
        for (let key in GridObj) {
          if (GridObj.hasOwnProperty(key)) {
            const dateKeys = ['ApprovedByDate', 'CreationDate', 'UpdationDate', 'DeletionDate'];
            const booleanKeys = ['IsDeleted', 'IsClosed', 'IsApproved'];
            if(key.endsWith('ID') || key.includes('ID') || booleanKeys.includes(key) || dateKeys.includes(key) ){
              delete GridObj[key]
            }else{
              if(key.includes('Date')){
                if(GridObj[key] instanceof Date){
                  GridObj[key] = moment(GridObj[key]).format('DD-MMM-YY')
                }
              }else if(key.includes('Rate')){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(2)
              
              }else if(!isNaN( GridObj[key])){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(1)
              }else{
                GridObj[key] = GridObj[key]
              }

            }
          }
          
        }
        // deleteDialog.current.hide();
        console.log(selectedRows)
        let obj={
          TableName:ListDelete[0].TableName,
          ColumnName:ListDelete[0].TableID,
          // DeleteSecurity:ListDelete[0]?.DeleteSecurity ?  ListDelete[0].DeleteSecurity : undefined,
          RowID:Array.isArray(ListDelete[0].TableID) ?  ListDelete[0].TableID.map(id => selectedRows[id]): selectedRows[ListDelete[0].TableID],
          SelectedRow:true,
          UserID:userId,
          IdentityField:selectedRows['IdentityField']
          // SelectedRowData:GridObj
            }
            if(ListDelete[0]?.TableSecurity){
              obj.DeleteSecurity = ListDelete[0]?.TableSecurity
              }
          setDeletingProps(obj)
        setShowDialogs(true)
      }
    } 
    } 

    if (grids.current[Id] && args.item.properties.id != undefined) {
      console.log(args.item.properties)
      if(args.item?.mustSelectRow == true){
        console.log(grids.current[Id].selectedRowIndex)
        if(selectedRows.length == 0){
          // let key=exportContractGrid.getSelectedRecords()[0]?.ExportContractID;
          // handleRedirectPlanning(key)
          let obj={
    
          }
          setDeletingProps(obj)
              setShowDialogs(true)
    
      }else{
        if(ToolbarClicking){   ToolbarClicking(grids.current[Id], args ,selectedRows  , getListService,saveData)
        }

      }
      }else{
        if(ToolbarClicking){  ToolbarClicking(grids.current[Id], args ,selectedRows  , getListService,saveData)
        }
        
      }
      
  }

  };


  // const getListService = async ( inside = false) => {
  //   console.log(GridDataSource);
  //   console.log(GridDataSource[0]);
  
  //   const handleDataProcessing = (data) => {
  //     return data.map((record) => {
  //       Object.keys(record).forEach((key) => {
  //         const lowerKey = key.toLowerCase();
          
  //         if (lowerKey.startsWith('isdeleted') || lowerKey.startsWith('isapproved')) {
  //           record[key] = record[key] ? 'Yes' : 'No';
  //         } else if (lowerKey.endsWith('date') && record[key]) {
  //           record[key] = new Date(record[key].split('T', 1)[0]);
  //         }
  //       });
  //       return record;
  //     });
  //   };
  
  //   const handleColumnCreation = (data) => {
  //     return data.map(item => {
  //       let newItem = { ...item };
  //       GridDataSource[0].CreateColumns.forEach(column => {
  //         newItem[column.columnName] = column.columnValue;
  //       });
  //       return newItem;
  //     });
  //   };
  
  //   const updateDataSourceState = (newData) => {
  //     const saveType = GridDataSource[0]?.DataSourceSaveType;
  //     if (saveType === 'replace') {
  //       setDataSourceState(newData);
  //     } else if (saveType === 'push') {
  //       setDataSourceState(prevArray => [...prevArray, ...newData]);
  //     } else {
  //       setDataSourceState(newData);
  //     }
  //   };
  
  //   if (GridDataSource[0].DataSourceType === 'Function' || inside == true) {
  //     try {
  //       setLoadingDataSourceState(true);
  //       setDataSourceState([])
  //       const response = await GridDataSource[0]?.DataSource();
  //       setLoadingDataSourceState(false);
  
  //       console.log(response);
  //       const processedData = handleDataProcessing(response.data.recordset);
  
  //       if (GridDataSource[0].CreateColumns && GridDataSource[0].CreateColumns.length > 0) {
  //         const addColumnData = handleColumnCreation(processedData);
  //         console.log(addColumnData);
  
  //         updateDataSourceState(addColumnData);
  //         return addColumnData;
  //       } else {
  //         updateDataSourceState(processedData);
  //         return processedData;
  //       }
  
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       setLoadingDataSourceState(false);
  //     }
  //   } else if (GridDataSource[0].DataSourceType === 'Reset') {
  //     setLoadingDataSourceState(false);
  //     setDataSourceState([]);
  //     return true;
  //   } else if (GridDataSource[0].DataSourceType === 'Data') {
  //     setDataSourceState([]);
  //     console.log(GridDataSource[0]?.DataSource);
  
  //     setTimeout(() => {
  //       setDataSourceState(GridDataSource[0]?.DataSource);
  //     }, 100);
  
  //     setLoadingDataSourceState(false);
  //   }
  // };
  
//   const getListService = async (inside = false, retryCount = 0) => {
//     console.log(GridDataSource);
//     console.log(GridDataSource[0]);

//     const maxRetries = 4;
//     const delay = 6000; // 6 seconds

//     const handleDataProcessing = (data) => {
//         return data.map((record) => {
//             Object.keys(record).forEach((key) => {
//                 const lowerKey = key.toLowerCase();

//                 if (lowerKey.startsWith('isdeleted') || lowerKey.startsWith('isapproved')) {
//                     record[key] = record[key] ? 'Yes' : 'No';
//                 } else if (lowerKey.endsWith('date') && record[key]) {
//                     record[key] = new Date(record[key].split('T', 1)[0]);
//                 }
//             });
//             return record;
//         });
//     };

//     const handleColumnCreation = (data) => {
//         return data.map(item => {
//             let newItem = { ...item };
//             GridDataSource[0].CreateColumns.forEach(column => {
//                 newItem[column.columnName] = column.columnValue;
//             });
//             return newItem;
//         });
//     };

//     const updateDataSourceState = (newData) => {
//         const saveType = GridDataSource[0]?.DataSourceSaveType;
//         if (saveType === 'replace') {
//             setDataSourceState(newData);
//         } else if (saveType === 'push') {
//             setDataSourceState(prevArray => [...prevArray, ...newData]);
//         } else {
//             setDataSourceState(newData);
//         }
//     };

//     if (GridDataSource[0].DataSourceType === 'Function' || inside === true) {
//         try {
//             setLoadingDataSourceState(true);
//             const response = await GridDataSource[0]?.DataSource();
//             setLoadingDataSourceState(false);

//             console.log(response);
//             let processedData = handleDataProcessing(response.data.recordset);

//             if (GridDataSource[0].CreateColumns?.length > 0) {
//                 processedData = handleColumnCreation(processedData);
//             }

//             updateDataSourceState(processedData);
//             return processedData;
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             setLoadingDataSourceState(false);

//             if (retryCount < maxRetries) {
//                 console.warn(`Retry attempt ${retryCount + 1} after ${delay / 1000} seconds`);
//                 setTimeout(() => getListService(inside, retryCount + 1), delay);
//             } else {
//                 console.error('Max retries reached. Failed to fetch data.');
//                 return false;
//             }
//         }
//     } else if (GridDataSource[0].DataSourceType === 'Reset') {
//         setLoadingDataSourceState(false);
//         setDataSourceState([]);
//         return true;
//     } else if (GridDataSource[0].DataSourceType === 'Data') {
//         setDataSourceState([]);
//         console.log(GridDataSource[0]?.DataSource);

//         setTimeout(() => {
//             setDataSourceState(GridDataSource[0]?.DataSource);
//         }, 100);

//         setLoadingDataSourceState(false);
//     }
// };

function sortByColumn(data, column, order = 'Aescending') {
  if (!Array.isArray(data)) {
    throw new Error("First argument must be an array");
  }

  const sorted = [...data].sort((a, b) => {
    const valueA = a[column];
    const valueB = b[column];

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return order === 'Aescending' 
        ? valueA.localeCompare(valueB) 
        : valueB.localeCompare(valueA);
    }

    return order === 'Aescending' 
      ? valueA - valueB 
      : valueB - valueA;
  });

  return sorted;
}


const isCheckboxField = (fieldName) => {
  console.log(ColumnProps)
 if(ColumnProps?.find(item => item.field.toLowerCase() == fieldName.toLowerCase())?.other[0]?.editType?.toLowerCase() == 'booleanedit') return true;
 return false;
}

const getListService = async (inside  = false) => {
  console.log(GridDataSource)
  console.log(inside)
  const maxRetries = 4;
  const delay = 6000; // 6 seconds 

  if (GridDataSource[0]?.DataSourceType === 'Function' || inside == true) {
    try {
      if(GridDataSource[0]?.DataSourceSaveType != 'push' ){ saveData([]) }

      setLoadingDataSourceState(true)

      const response = await GridDataSource[0]?.DataSource();
      setLoadingDataSourceState(false)

      console.log(response)
      
      const filters = GridDataSource[0]?.FilterData;

      if (Array.isArray(filters) && filters.length > 0) {
        response.data.recordset = response.data.recordset.filter((item) => {
          return filters.every(({ field, value, operator }) => {
            switch (operator) {
              case '==':
                return item[field] == value;
              case '===':
                return item[field] === value;
              case '!=':
                return item[field] != value;
              case '!==':
                return item[field] !== value;
              case '>':
                return item[field] > value;
              case '>=':
                return item[field] >= value;
              case '<':
                return item[field] < value;
              case '<=':
                return item[field] <= value;
              default:
                return true;
            }
          });
        });
      }

      console.log(response.data.recordset);
      if(DefaultSortedColumnName != undefined && DefaultSortedColumnName != ''){

        response.data.recordset =  sortByColumn(response.data.recordset, DefaultSortedColumnName, DefaultSortedColumnSort)
      }
        

      const data = response.data.recordset.map((record, index) => {
        console.log("Before:", record);
        Object.keys(record).forEach((key) => {
          
          if (
            key.toLowerCase().startsWith("isdeleted") ||
            key.toLowerCase().startsWith("isapproved") ||
            key.toLowerCase().startsWith("isclosed")
             ||
            isCheckboxField(key)   == true
          ) {
            record[key] = record[key] === true ? "Yes" : record[key] === false ? "No" : record[key];
          }else if(key.toLowerCase().endsWith("date")){
            record[key] = new Date(moment(record[key].split('T', 1)[0]));
          }
        });
        console.log("After:", record);
        return record;
      });
      console.log("Final mapped data:", data);
      
// const data = response.data.recordset;
    console.log(data)
      if(GridDataSource[0].CreateColumns && GridDataSource[0].CreateColumns.length > 0){
          let addColumn = data.map(item => {
            // Create a new object to avoid mutating the original item
            let newItem = { ...item };
          
            // Iterate over each column definition and add it to the new item
            GridDataSource[0].CreateColumns.forEach(column => {
              newItem[column.columnName] = column.columnValue;
            });
          
            return newItem;
          });
          console.log(addColumn)
          console.log(addColumn)
          // setDataSourceState(addColumn);
          console.log(GridDataSource[0]?.DataSourceSaveType)
      if(GridDataSource[0]?.DataSourceSaveType == 'replace'){
        saveData(addColumn);
      }else if(GridDataSource[0]?.DataSourceSaveType == 'push'){
          // setDataSourceState((prevArray) =>{
          //               console.log(prevArray)
          //               return [
          //                 ...prevArray,
          //                 ...addColumn
          //                 // ...addColumn[0]
          //               ]
          //             })
          // setDataSourceState(prevState => ({
          //   ...prevState,
          //   [Id]: DefaultSortedColumnSort == "Descending"
          //     ? [...(prevState[Id] || []), ...addColumn]  // Add at the end
          //     : [...addColumn, ...(prevState[Id] || [])]  // Add at the start
              
          // }));
          saveData(addColumn,'push');
          
          // setDataSourceState(prevState => ({
          //   ...prevState,
          //   [Id]: [...(prevState[Id] || []), ...addColumn],  // Append new data to existing data for the Id
          // }));
      }else{
        saveData(addColumn);

      }
    return addColumn

      }else{
        if(GridDataSource[0]?.DataSourceSaveType == 'replace'){
          saveData(data);
        }else if(GridDataSource[0]?.DataSourceSaveType == 'push'){
          console.log(data)
            // setDataSourceState((prevArray) =>{
            //               console.log(prevArray)
            //               return [
            //                 ...prevArray,
            //                 ...data
            //                 // ...addColumn[0]
            //               ]
            //             })
            // setDataSourceState(prevState => ({
            //   ...prevState,
            //   [Id]: DefaultSortedColumnSort == "Descending"
            //     ? [...(prevState[Id] || []), ...data]  // Add at the end
            //     : [...data, ...(prevState[Id] || [])]  // Add at the start
                
            // }));
            saveData(data,'push')
            // setDataSourceState(prevState => ({
            //   ...prevState,
            //   [Id]: [...(prevState[Id] || []), ...data],  // Append new data to existing data for the Id
            // }));
        }else{
          console.log(data)
          saveData(data);


        }
        return data
      }
  } catch (e) {
    // if (retryCount < maxRetries) {
    //   console.warn(Retry attempt ${retryCount + 1} after ${delay / 1000} seconds);
    //   setTimeout(() => getListService(retryCount + 1), delay);
    // } else {
    //   console.error('Max retries reached. Failed to fetch data.');
    //   return false;
    // }     
    setLoadingDataSourceState(false)
  }
} else if(GridDataSource[0]?.DataSourceType === 'Reset') {
  // accessoryBOMService.getAccessoryBOMForList()
  //   .then((response) => {
  //     setDataSourceState(response.data.recordset);
  //   })
  //   .catch((e) => {
  //   });
  setLoadingDataSourceState(false)
  saveData([])
  return true
}
 if(GridDataSource[0]?.DataSourceType == 'Data'){
   saveData([]);
  console.log(GridDataSource[0]?.DataSource);
  if (GridDataSource[0]?.DataSource?.length > 0) {
    const data = GridDataSource[0].DataSource.map((record, index) => {
      
        console.log("Before:", record);
        Object.keys(record).forEach((key) => {
          
          if (
            key.toLowerCase().startsWith("isdeleted") ||
            key.toLowerCase().startsWith("isapproved") ||
            key.toLowerCase().startsWith("isclosed")
             ||
            isCheckboxField(key)   == true
          ) {
            record[key] = record[key] === true ? "Yes" : record[key] === false ? "No" : record[key];
          }else if(key.toLowerCase().endsWith("date")){
            record[key] = new Date(
              moment(
                typeof record[key] === 'string' && record[key].includes('T')
                  ? record[key].split('T')[0]
                  : record[key]
              )
            );
            // record[key] = new Date(moment(record[key]).format('YYYY-MM-DD'));

            // record[key] =record[key];
          }
        });
        console.log("After:", record);
        return record;
      });
      console.log("Final mapped data:", data);
  
    setTimeout(() => {
      console.log(data);
      saveData(data);
    }, 100);
  
    setLoadingDataSourceState(false);
  }
  



 }
    }
    // return true
// }  };
  // useEffect(() => {
  // }, []);

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

      let toolbarOptions = ToolbarOption;  // Assign directly from the input
      
// Check if toolbarOptions is a string and equals 'All'
if (typeof toolbarOptions === 'string' && toolbarOptions === 'All') {
  // toolbarOptions = ['Add', 'Edit', { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('MadeupTransferTransactionsDelete') }, 'Update', 'Cancel', 'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'];
  toolbarOptions = ['Add', 'Edit', { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !true }, 'Update', 'Cancel', 'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'];
} else if (Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  // Ensure toolbarOptions is an array and run the existing condition
  toolbarOptions = [...toolbarOptions];
  let deleteIndex = toolbarOptions.findIndex(res => res === 'Delete');
  if (deleteIndex !== -1) {
    // toolbarOptions[deleteIndex] = { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('MadeupTransferTransactionsDelete') };
    toolbarOptions[deleteIndex] = { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !true };
  }
} else if (Array.isArray(toolbarOptions) && toolbarOptions.length === 0) {
  toolbarOptions = null;
}
     // Check if AllowPdfExport is false and remove PDFExport from toolbarOptions if present
if (!AllowPdfExport && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'PDFExport');
}

// Check if AllowExcelExport is false and remove ExcelExport from toolbarOptions if present
if (!AllowExcelExport && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'ExcelExport');
} 
if (!ShowColumnChooser && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'ColumnChooser');
} 
      

  const databound = (AllowDataBoundd  = false) => {
    setTimeout(()=>{
    if (grids.current[Id] && AllowDataBoundd == true && dataSourceState[Id]?.length > 0  && loadingdataSourceState == false

    ) {
       if(grids.current[Id]?.autoFitColumns()){
        grids.current[Id].autoFitColumns();
      }
      
      }
    },400)
  }
 
  // const dialogTemplate = (props) => {
  //   //  { isAdd, GridDialog, dataSourceState } 
  //   const { DialogType, Dialog } = GridDialog[0];
  //   if(DialogType === 'Self'){
  //   var DialogProps = Dialog.props
  //   var SelfDialog = Dialog.type}
  //   if (props.isAdd) {
  //     return DialogType === 'Master' ? (
  //       <IrtizDynamicInputAdd {...props} dataList={dataSourceState} />
  //     ) : DialogType === 'Self' ? (
  //       <SelfDialog {...DialogProps} {...props}  dataList={dataSourceState}/>

  //       // <InvoiceEvaluationAdd {...props} dataList={dataSourceState} />
  //   ): (
  //       <IrtizDynamicInputAdd {...props} dataList={dataSourceState} />
  //     );
  //   } else {
  //     return DialogType === 'Master' ? (
  //       <IrtizDynamicInputAdd {...props} dataList={dataSourceState} />
  //     ) : DialogType === 'Self' ? (
  //       <SelfDialog {...DialogProps} {...props}  dataList={dataSourceState}/>
  //     ) : (
  //       <IrtizDynamicInputAdd {...props} dataList={dataSourceState} />
  //     );
  //   }
  // };
  
  const dialogTemplate = (props) => {
    //  { isAdd, GridDialog, dataSourceState } 
   return(
    <div></div>
   )
  };
  
console.log(typeof(EditSecurity) == 'boolean')
  const editSettings: EditSettingsModel = {
    
    allowEditing: typeof(EditSecurity) == 'boolean' ? EditSecurity :  SecurityService.canUserAccess(EditSecurity == '' ? `${Id}List`:EditSecurity),
    allowAdding: typeof(AddSecurity) == 'boolean' ? AddSecurity :  SecurityService.canUserAccess(AddSecurity == '' ? `${Id}List`:AddSecurity),
    allowDeleting: typeof(DeleteSecurity) == 'boolean' ? DeleteSecurity :  SecurityService.canUserAccess(DeleteSecurity == '' ? `${Id}Delete`:DeleteSecurity),
  //   allowDeleting: true,

  //  allowEditing: true,
  //  allowAdding: true,
    // allowDeleting: true,

    mode: GridEditSettingMode,
    showDeleteConfirmDialog: true,
    headerTemplate:GridEditSettingHeaderTemplate
   };
   if(GridEditSettingMode == 'Dialog'){
    // editSettings.template= dialogTemplate;

   }
    
  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
    columns: filterState

  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
    columns: groupState
  };

  // const footerSum = (e: any) => {
    
  //   console.log(e)

  //   return <span> Sum: {e.Sum}</span>;

  // };
  const footerSum = (e: any) => {
    // Extract the second index key from the object
    const keys = Object.keys(e);
    console.log(e)
    // if (keys.length < 2) return null; // If there are fewer than two keys, return null or a fallback
    console.log(keys)
  
    const secondKey = keys[0];
    const sumValue = e[keys[1]];
  
    // Check if this key exists in the FooterSumCaption array
    const matchedCaption = FooterSumCaption.find(item => item.ColumnName === secondKey);
  
    // If a match is found, replace the caption
    const caption = matchedCaption ? matchedCaption.Caption : 'Sum';
  
    // Log for debugging purposes
    console.log(`Key: ${secondKey}, Value: ${sumValue}, Caption: ${caption}`);
  
    return <span>{caption}: {sumValue}</span>;
  };
  const actionBagin = (args) =>{
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {


    }
  }
  const addUserLog = (inputName ,tableName,tableID,values)=>{
    console.log(inputName,tableName,tableID,values)
    AuditTableInput.auditAdd(inputName,tableName,tableID,values)
  }
  
  const editUserLog = (tableName,tableIDValue,selectedRows,values)=>{
    console.log(tableName,tableIDValue,values)
    
    let totalColumns = Object.keys(values);
    console.log(totalColumns)
  
    AuditTableInput.auditEdit(totalColumns,selectedRows,values,tableName,tableIDValue)
  }
  var visibleSortPassFields = useRef([defaultSortColumnName])
  var visibleSortPass = useRef([defaultSortColumnType])
  var ctrlPressed =  useRef(false)
  var groupingArray = []
  const actionComplete = (args: DialogEditEventArgs) => {
    if(args.requestType == "grouping"){
      groupingArray.push(args.columnName)
    }
    if(args.requestType == "ungrouping"){
      groupingArray.splice(groupingArray.indexOf(args.columnName),1)
    }
    ctrlPressed.current = false;
    let handleStore = (e) => {
      e.stopPropagation();
      return  ctrlPressed.current = e.ctrlKey; // Use e.ctrlKey, not e.ctrlkey
    };
    document.addEventListener('keydown', handleStore);
    setTimeout(() => {
      if(args.requestType ==  'sorting'){
        setTimeout(() => {
          if(ctrlPressed.current == true ){
            if(args.columnName == visibleSortPassFields.current[0] && visibleSortPassFields.current.length == 1){
            }else{
              if(visibleSortPassFields.current.includes(args.columnName)){
                visibleSortPass.current[visibleSortPassFields.current.indexOf(args.columnName)] = args.direction;
              }else{
                visibleSortPassFields.current.push(args.columnName)
                visibleSortPass.current.push(args.direction)
              }
            }
            setTimeout(() => {
              return ctrlPressed.current = false;
            }, 200);
          }else{
            visibleSortPassFields.current =[args.columnName]
            visibleSortPass.current = [args.direction]
          }
        }, 80);
        
        setTimeout(() => {
          
        }, 300);
          }
        }, 200);
          if(args.requestType == 'filtering'  && args.action == 'filter'){
            let filterArray = [...filterColumnName , args.currentFilteringColumn]
            filterColumnName = filterArray.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    }
    
    if (args?.requestType === 'columnstate') {
      grids.current[Id]?.autoFitColumns();
    }
    if(args.requestType == 'filtering'  && args.action == "clear-filter"){
      if(recordColumnName.includes(args.currentFilteringColumn)){

        recordColumnName.splice(recordColumnName.indexOf(args.currentFilteringColumn),1)
        
        fiterCheckedValue.splice(recordColumnName.indexOf(args.currentFilteringColumn),1)
        if(filterColumnName.includes(args.currentFilteringColumn) ){
          filterColumnName.splice(filterColumnName.indexOf(args.currentFilteringColumn),1)
        }
      }
   
    }
    if(args.requestType == 'filtering'  && args.action == 'filter'){
      if(!recordColumnName.includes(args.currentFilteringColumn)){
        const filteredData = grids.current[Id].getFilteredRecords();
        let checkedValue   = filteredData.map((val)=>{ return val[args.currentFilteringColumn]}).filter((value, index, self) => { return self.indexOf(value) === index })
        recordColumnName = [...recordColumnName , args.currentFilteringColumn]
        fiterCheckedValue = [...fiterCheckedValue , checkedValue]
        }else{
      
      fiterCheckedValue.splice(recordColumnName.indexOf(args.currentFilteringColumn) , 1)
        const filteredData = grids.current[Id].getFilteredRecords();
        let checkedValue   = filteredData.map((val)=>{ return val[args.currentFilteringColumn]}).filter((value, index, self) => { return self.indexOf(value) === index })
        fiterCheckedValue = [...fiterCheckedValue , checkedValue]
        
      } 
  }
  
  console.log(args)
  console.log(autoCompleteInstances)
  console.log(checkboxInstances)

      let dropDownArgs = Object.keys(autoCompleteInstances).map((res, ind) => {
        console.log(res)
        console.log(autoCompleteInstances[res].dropdownValues)
        return autoCompleteInstances[res].dropdownValues;
    });
      let checkboxArgs = Object.keys(checkboxInstances).map((res, ind) => {
        console.log(res)
        console.log(checkboxInstances[res])
        return {[checkboxInstances[res].name]:checkboxInstances[res].checked};
    });
    
    let mergedObject = dropDownArgs.filter(item => item !== undefined)
        .reduce((acc, curr) => {
            return {...acc, ...curr};
        }, {});  


        console.log(checkboxArgs)
    let mergedCheckboxObject = checkboxArgs.filter(item => item !== undefined)
        .reduce((acc, curr) => {
            return {...acc, ...curr};
        }, {});  

    
    console.log(mergedCheckboxObject)
     if (args.data) {
      Object.assign(args.data, mergedObject,mergedCheckboxObject);
  }
  if (args.rowData) {
      Object.assign(args.rowData, mergedObject,mergedCheckboxObject);
  }

  console.log(args)
  const selectRowByID=(id)=>{
    console.log(id)
setTimeout(() => {
  if(grids.current[Id]?.currentViewData.length > 0 && grids.current[Id]) {
  grids.current[Id].selectRow(id)
  }
  
}, 200);

}
const startEdit =()=>{
  setTimeout(() => {
    if(grids.current[Id]?.currentViewData.length > 0 && grids.current[Id]){

    grids.current[Id].startEdit()
    }
  }, 400);
  }

if(args.requestType == 'add' || args.requestType == 'beginEdit'){
  
  if (Array.isArray(ColumnsList)) {
    ColumnsList.forEach( async (e, ind) => {
      console.log(e, ind);
      if(Array.isArray(e.other) && e.other.some((e)=>e.endEdit == true) && e.other[0].hasOwnProperty('endEdit')){
        document.getElementById(`${Id}Grid${e.field}`).addEventListener('keydown',(tab)=>{
           
           
           if(tab.code == 'Tab' ||  tab.key == 'Tab' ){
            tab.preventDefault()
            setTimeout(() => {
              
              // console.log(autoCompleteInstances['obj_BudgetItemID'].dropdownValues)
              if(e.other.some((e)=>e.editType == "dropdownedit")){
                let dynamicKey = `obj_${e.other[0].edit.field.id}`; // Create a dynamic key
                if(autoCompleteInstances[dynamicKey].dropdownValues){
                // BudgetingAccessoryDetailGridRate
                return document.getElementById(`${Id}Grid${e.field}`) && grids.current[Id].endEdit()
                  // document.getElementById('TenantContractGrid_dialogEdit_wrapper').scrollTo({
                  //     top: '100px',
                  //     behavior: "smooth"  // Optional: adds smooth scrolling
                  //   });
                }
              }else{
                return document.getElementById(`${Id}Grid${e.field}`) && grids.current[Id].endEdit()
                  

              }
            
            }, 200);
            if(document.getElementById(`${props?.GridID}Grid_dialogEdit_wrapper`)){
            document.getElementById(`${props?.GridID}Grid_dialogEdit_wrapper`).scrollTo({
              top: '100px',
              behavior: "smooth"  // Optional: adds smooth scrolling
            });
          }
          }
        })
      }else if(Array.isArray(e.other) && e.other.some((e)=>e.focus == true) && e.other[0].hasOwnProperty('focus')){
        
        if(document.getElementById(`${Id}Grid${e.field}`)){
          document.getElementById(`${Id}Grid${e.field}`).focus()
        }
      }
    });
  } else {
    console.error("ColumnsList is not an array");
  }
  
}





if(args.requestType == 'add' || EditActionCompleteType == 'Add'){
  console.log(ColumnsList);

  if (Array.isArray(ColumnsList)) {
    ColumnsList.forEach( async (e, ind) => {
      console.log(e, ind);
      
      if (Array.isArray(e.other) && e.other.some(obj => obj.hasOwnProperty('initialValue'))) {
        console.log(e);
        if(e.other.some((e)=>e.editType == "numericedit")){
          console.log(e)
if(document.getElementById(`${Id}Grid${e.field}`)){
  let formatValue = e.other[0]?.format ? 
  (
    e.other[0]?.format == 'n0' || e.other[0]?.format == 'N0'?
    parseInt(args.rowData[e.field]):
    parseFloat(args.rowData[e.field]).toFixed(e.other[0]?.format[1])
  )
  : parseInt(args.rowData[e.field]);
          document.getElementById(`${Id}Grid${e.field}`).value = args.rowData[e.field] ? formatValue :  e.other[0].initialValue;
          }
        }else if(e.other.some((e)=>e.editType == "datepickeredit")){
          if(e.other[0].initialValue == 'currentDate'){
            console.log(`${Id}Grid${e.field}`)
            if(document.getElementById(`${Id}Grid${e.field}`)){
            // document.getElementById(`${Id}Grid${e.field}`).value = moment().format('DD/MM/YY')
            }
            if(document.getElementById(`${Id}Grid${e.field}`)){
            document.getElementById(`${Id}Grid${e.field}`).value = moment().format('dd-MMM-yy')
            }
          }else{
            if(document.getElementById(`${Id}Grid${e.field}`)){
            document.getElementById(`${Id}Grid${e.field}`).value = args.rowData[e.field] ? args.rowData[e.field] : e.other[0].initialValue
            }
            
          }
        }
        else if(e.other.some((e)=>e.editType == "booleanedit")){
          if(document.getElementById(`${Id}Grid${e.field}`)){
          // console.log(document.getElementById(`${Id}Grid${e.field}`));
          }
          // .checked = true
          if(document.getElementById(`${Id}Grid${e.field}`)){
          // document.getElementById(`${Id}Grid${e.field}`).defaultValue = false
          }
          
        }else{
          if(document.getElementById(`${Id}Grid${e.field}`)){
            document.getElementById(`${Id}Grid${e.field}`).value = args.rowData[e.field] ? args.rowData[e.field] : e.other[0].initialValue
            }
        }
      }else if(Array.isArray(e.other) && e.other.some((e)=>e.editType == "dropdownedit") &&  e.other[0].edit.hasOwnProperty('initialValue')){
        console.log('dd', e)
        let dynamicKey = `obj_${e.other[0].edit.field.id}`; // Create a dynamic key

        
            if(e.other[0].edit.initialValue?.id != '' && e.other[0].edit.initialValue?.id != undefined ){
              
              console.log('dd>', e);
              const response = await DropdownService.getAllForList(e.other[0].edit?.source.dataSource);
              if (response.data && response.data.recordset) {
                console.log(autoCompleteInstances[dynamicKey].dataSource);

            // let fetchingObject = autoCompleteInstances[`obj_${e.other[0].edit.field.id}`].dataSource.filter((val)=>val?.id == e.other[0].edit.initialValue?.id );
            let fetchingObject = response.data.recordset.filter((val)=>val?.id == e.other[0].edit.initialValue?.id );
            if(fetchingObject.length > 0 ){
            console.log(fetchingObject)
            autoCompleteInstances[dynamicKey].dropdownValues =  {[e.other[0].edit.field.id]:fetchingObject[0].id  ,  [e.other[0].edit.field.value]:fetchingObject[0].value}
            autoCompleteInstances[dynamicKey].value =fetchingObject[0].value;
            autoCompleteInstances[dynamicKey].id =fetchingObject[0].id;
            args.rowData[e.other[0].edit.field.id] = fetchingObject[0].id;
            // document.getElementById(`${Id}Grid${e.field}`).value = e.other[0].initialValue;
            }
          }
          
        }
   
     
      }
      
    });
  } else {
    console.error("ColumnsList is not an array");
  }
  
}
 
  if(ListActionComplete ){
    
  ListActionComplete(
        grids.current[Id],
        args,
        saveData,
        // setDataSourceState,
        getListService ,
         selectedRows ,
         selectRowByID,
         startEdit,
         addUserLog,
         editUserLog,
         dataSourceState[Id].length,
         dataSourceState[Id]
        )}
            

    }

  // const commandClick = (args: CommandClickEventArgs) => {
  //   setShowDialog(false);
  //   setSelectedRow(args.rowData);
  //   setShowDialog(true);
  // };

  // const commands: CommandModel[] = [
  //   {
  //     buttonOption: {
  //       content: 'Delivery Schedule',
  //       cssClass: 'e-flat',
  //     },
  //   },
  // ];

  // const dialogClose = () => {
  //   this.buttonInstance.style.display = 'inline-block';
  //   setShowDialog(false);
  // };

  

  
  const sortingOptions: SortSettingsModel = {
    columns: DefaultSortedColumnName ? [{ field:DefaultSortedColumnName, direction: DefaultSortedColumnSort }] : []
  }
  const userId = SecurityService.getLoggedInUserId();
      
 // DYNAMIC TEMPLATE CODE

 const getFieldFormat = (fields, fieldName) => {
  const fieldObj = fields.find(field => field.field === fieldName);
  if (!fieldObj) return undefined;

  const otherObj = fieldObj.other?.find(item => item.format);
  return otherObj ? otherObj.format : undefined;
};


 const GridSum = (GridSumColumns , ColumnsList)=>{
// Initialize gridSum as an empty array
let gridSum = [];

if(AllowGridSum  == true){

if (GridSumColumns.length > 0) {
  // Map over GridSumColumns to set format based on conditions
  gridSum = GridSumColumns.map((column) => {
    if (column.includes('Rate') || column.endsWith('Percent')) {
      return {
        field: column,
        format:  getFieldFormat(ColumnsList,column) || 'n2', // Format for Rate or Percent
      };
    } else {
      return {
        field: column,
        format:getFieldFormat(ColumnsList,column) || 'n0', // Default format
      };
    }
  });
} else {
  // If GridSumColumns is empty, map over ColumnsList
  gridSum = ColumnsList.map((column) => {
    // Check if format is defined in other[0]
    if (column.other[0]?.format) {
      return {
        field: column.field,
        format: column.other[0]?.format || 'n0',
      };
    }
  }).filter((result) => result !== undefined); // Filter out undefined results
}
      }else{
  gridSum = [
    {
      field:'dontmakesum',
      format: 'n0',
    }
  ]
}
// Log the resulting gridSum array
console.log(gridSum)
if (!gridSum ||  gridSum.length == 0 ) return null;

return( 
  
  <AggregatesDirective>

  <AggregateDirective>
    <AggregateColumnsDirective>
      {
gridSum.map((res,key)=>{
return(<AggregateColumnDirective  footerTemplate={footerSum} key={key} field={res.field} type='Sum' format={res.format} />)
})}
    </AggregateColumnsDirective>
  </AggregateDirective>

  <AggregateDirective>
    <AggregateColumnsDirective>
    {
gridSum.map((res,key)=>{
return(<AggregateColumnDirective   groupFooterTemplate={footerSum} key={key}  field={res.field} type='Sum' format={res.format} />)
})}
      
     

    </AggregateColumnsDirective>
  </AggregateDirective>

</AggregatesDirective>
)
 }

 const onClosing = (e)=>{
  console.log(e);
  // irtizaDynamicGrid.refresh();
  getListService(true);
 }
 const ListGridComponent = useMemo(()=> {
  return ({ restrictPageSize = 12 }) => {
     // Storing grid instances by dynamic keys
    //  const handleGridRef = (grid,ID) => {
    //   if (grid) {
    //     grids.current[Id] = grid;
    //   }
    // };

    const handleGridRef = (grid: Grid , Id) => {
      if (grid) {
        grids.current[Id] = grid; // Store grid instance with its ID
      }
    };
  
  

  ColumnProps = ColumnsList.map(column => {
    if (column.field.endsWith('Date') || column.other[0]?.editType == 'datepickeredit') {
        return {
            ...column,
            other: [{  'format': formatOptions , ...column.other[0] }]
        };
    }else if( 
      column.other[0]?.editType == 'booleanedit' ||  column.field.toLowerCase().startsWith('isdeleted') || column.field.toLowerCase().startsWith('isapproved') || column.field.toLowerCase().startsWith('isclosed')  || column.field.toLowerCase().startsWith('is')
    ) {
      const activeCheckboxEditor = createCheckbox({
        field:  column.field ,
        caption: column.caption,
        checked:column.other[0].initialValue  == 'true' ? true : false,
        //  checked:true ,
        onChange: (checked, args, key) => {
          console.log('Checkbox Changed:',args);
          console.log('Checkbox Changed:',key);
          console.log('Checkbox Changed:', checked, key);
          if(column.other[0]?.onChange){
            column.other[0]?.onChange(checked, args, key)
          }
        }
      });
      
      return {
        ...column,
        other: [
          {
            ...column.other[0],
            edit:{
                create: activeCheckboxEditor.create,
              write: activeCheckboxEditor.write,
              destroy: activeCheckboxEditor.destroy,
              read: activeCheckboxEditor.read,
              
            },
            template: (props) => (  
              <p style={{ margin: '0px' }}>
                {props[column.field] === true ? 'Yes' : props[column.field] === false ? 'No': props[column.field]}
              </p>
            ),
          },
        ],
      };
    }else if(column.other.length > 0  && column.other[0].editType == 'dropdownedit') {
      return {
        ...column,                                                  
        other: [{...column.other[0],  edit:createAutoComplete(column.other[0].edit) }]
          
    }
  }else if(column.other.length > 0  && column.other[0].editType == 'numericedit') {
      return {
        ...column,                                                  
        // other: [{...column.other[0],  edit:createNumericInput(column.other[0].edit ,column.headerText) }]
        other: [{...column.other[0], 
          edit:{
            params: {
              placeholder: `Enter ${column.other[0].edit?.caption || column.headerText} `,
              floatLabelType: "Never",
              cssClass: column?.textAlign == 'right' || column?.textAlign == 'Right' ? "GridNumericInput" :"GridTextInput" ,
              min: column.other[0].edit?.min || 0,
              max: column.other[0].edit?.max || Infinity,
              step: column.other[0].edit?.step || 1,
              //value:column.other[0].edit?.defaultValue,
              format: column.other[0].edit?.format || "n0", // Default to 2 decimal places
              // textAlign: 'Right',
              
            },
            // style:{
            //   textAlign:'right'
            // }
        }
          // edit:{
          //   create: () => createNumericInput(column.other[0].edit ,column.headerText, column.field).create(),
          //   destroy: () => createNumericInput(column.other[0].edit ,column.headerText).destroy(),
          //   read: () => createNumericInput(column.other[0].edit ,column.headerText).read(),
          //   write: (args) => createNumericInput(column.other[0].edit ,column.headerText).write(args),
          // }
        }]
          
    }
    }
    // else if(column.other.length > 0  && column.other[0].editType == 'multidropdownedit') {

    //   let dynamicKey = `obj_${column.other[0].edit.field.id}`;
    //   console.log(dynamicKey)
    //         autoCompleteInstances[dynamicKey] = {dataSource:[]}
    //   return {
    //     ...column,                                                  
    //     other: [{ editTemplate:()=><CreateAutoCompleteComponent  dataSource={autoCompleteInstances[column.other[0].edit.field.id].dataSource}/> }]

    //     // {...column.other[0].edit}
          
    // }
    // }
    // else if(column.other.length > 0  && column.other[0].editType == 'multidropdown') {
    //   return {
    //     ...column,                                                  
    //     other: [{ editTemplate:(props)=> <CreateMultiDropDown {...props} {...column.other[0].edit} /> }]
          
    // }
    // }
    return column;
});
  // const addedColumns = useMemo(() => {
  const addedColumns = () => {
    if(GridDataSource[0]?.CreateColumns && GridDataSource[0]?.CreateColumns.length > 0){
  
      return GridDataSource[0]?.CreateColumns.map((field, index) => {
      
          return (
            <ColumnDirective
              key={index} // You may use index as key here if there is no unique field key available
              // direction={visibleSort[index]}
              field={field.columnName}

              visible={false}
            />
          );
        })
      
    } else {
      return null
    }
  // }, [ GridDataSource[0].CreateColumns.length > 0]);
  };
  let addColumnss = addedColumns()
  // const columns = useMemo(() => {
  const columns = () => {
    if (ColumnProps.length > 0) {
      return ColumnProps.map((field, index) => {
        if (field.field == 'Commands') {
          return (
            // <ColumnDirective
            //   key={index} // You may use index as key here if there is no unique field key available
            //   headerText={field.headerText}
            //   width={field.width}
            //   headerTextAlign={field.headerTextAlign}
            //   textAlign={field.textAlign}
            //   style={{textAlign:field.textAlign}}
            //   {...field.other[0]}
              
            //   // direction={visibleSort[index]}
            // />
            <ColumnDirective
            key={index} // Use index as a key if a unique key is not available
            headerText={field.headerText}
            width={field.width}
            template={(args) => {
              console.log(args)
              return (
                  <div style={{
                    gap: '10px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    width:field.width
                }}>
                      {field.other[0].button.map((btn, index) => (
                          <DialogInput
                              key={index} // Use a unique key for each button
                              Route={btn?.Input?.Route}
                              Security={btn?.Input?.Security}
                              OnClosed={onClosing}
                              Title={btn?.Content} // Use the dynamic title from the button object
                              InputTitle={btn?.Input?.Title} // Use the dynamic input title from the button object
                              Width={btn?.Input?.Width} // Use the dynamic input title from the button object
                              SelectedRow={args}
                              BgColor={btn?.BgColor}
                              Color={btn?.Color}
                          />
                      ))}
                  </div>
              );
          }}
          
            headerTextAlign={field.headerTextAlign}
            textAlign={field.textAlign}
            {...field.other[0]}
            // direction={visibleSort[index]}
          />
          );
        } 
        // else if(index == 3){
        //   return (
        //     <ColumnDirective
        //     key={'SaleProductID'}
        //     headerText={'Product Name'}
        //     id={'SaleProductName'}
        //     field={'SaleProductName'}
        //     width={400}
        //     headerTextAlign={'center'}
        //     textAlign={'left'}
        //     editTemplate={(props)=>{
        //       // console.log(saleProductNameDataSource)
        //       return(
        //         <>
        //         <AutoCompleteComponent 
        //         // dataSource={saleProductNameDataSource}
        //         fields={ddlFields}
        //         ref={saleProduct}
        //         floatLabelType='Auto' 
        //         highlight={true}
        //         />
        //         </>
        //       )
        //     }}
        //     // {...field.other[0]}
            
        //     // direction={visibleSort[index]}
        //     />
        //     );
        // }
        else {
        

            return (
              <ColumnDirective
              key={field.field}
              headerText={field.headerText}
              id={field.field}
              field={field.field}
              width={field.width}
              headerTextAlign={field.headerTextAlign}
              textAlign={field.textAlign}
              // style={{textAlign:field.textAlign}}
              // type='number'
              {...field.other[0]}
              
              // direction={visibleSort[index]}
              />
              );
            
        }
      });
    } else {
      return <ColumnDirective field='IsDeleted' visible={false} />; // You don't need to wrap it with () here
    }
  // }, [ColumnProps.length > 0]);
  }

  let CreateColumns =  columns()
  
return (
    <GridComponent
          // ref={(grid) => (grids.current[Id] = grid)}
          // ref={(grid) => (grids.current[Id] = grid)}
          // ref={(grid) => handleGridRef(grid, Id)} // Using a unique ID for each grid
          ref={(grid) => handleGridRef(grid, Id)} // Storing grid by its unique ID

          id={`${Id}Grid`}
          dataSource={dataSourceState[Id]?.length > 0 ? dataSourceState[Id] : []}
          editSettings={editSettings}
          pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
          toolbar={toolbarOptions}
          toolbarClick={toolbarClick}
          allowExcelExport={AllowExcelExport}
          allowPdfExport={AllowPdfExport}
          showColumnChooser={ShowColumnChooser}
          allowPaging={AllowPaging}
          allowGrouping={AllowGrouping}

          filterSettings={filterOptions}
          groupSettings={groupOptions}
          actionComplete={(args) => actionComplete(args, Id)} // Pass the Id to distinguish grids
          actionBegin={(args) => actionBagin(args, Id)}
          allowTextWrap='true'
          rowDataBound={rowDataBound}
          allowSorting={DefaultSortedColumnName?true:false}
          allowFiltering={AllowFiltering}
          allowReordering={true}
          allowResizing={true}
          sortSettings={DefaultSortedColumnName ? sortingOptions :{}}
          dataBound={databound(AllowDataBound)}
       
          rowSelected={
            (args)=>{
              console.log(args)
              
              selectedRows = args.data
              selectedRowIndex  = args.rowIndex
              setTimeout(() => {
                          ToolbarClicking(grids.current[Id], args ,args.data,getListService,saveData)
                
              }, 200);
            }
          }
          rowDeselected={
            (args)=>{
              console.log(args)
              ToolbarClicking(grids.current[Id], args ,args.data ,getListService,saveData)
              selectedRows = []
              selectedRowIndex  = undefined
            }
          }
        >
            <ColumnsDirective>
          {CreateColumns}
          {addColumnss}
            </ColumnsDirective>
        {GridSum( GridSumColumns, ColumnsList )}

          <Inject
            services={[
              Edit,
              Toolbar,
              Page,
              Sort,
              PdfExport,
              ExcelExport,
              Filter,
              Group,
              Aggregate,
              Freeze,
              ColumnChooser,
              Reorder,
              Resize,
              CommandColumn,
            ]}
          />
        </GridComponent>

)
}
},[dataSourceState[Id]]);
// DYNAMIC TEMPLATE CODE
  const getColumnsDetail = ()=>{
    return grids.current[Id].getColumns()
  }

return (
    <div className='' >
      <div>
            <div>
            {AllowTemplate == true ? 
              <h3>{
                }
              {/* // DYNAMIC TEMPLATE CODE */}
              {AllowTemplate == true ? <button 
              onClick={(e)=>{ e.preventDefault();setIsToggled(!isToggled)}}
              className={`toggle-templete ${isToggled ? 'active' : ''}`}
              >
       {ToggledValue}               
          </button >:null }
          {/* isToggled ,
  ColumnProps ,
  getListService ,
  getColumns , 
  InputListSecurity ,
  visibleSortPassFields ,
  visibleSortPass ,
  groupingArray ,
  defaultSortColumnName ,
  defaultSortColumnType */}
              </h3> : null}
               
               
              <div>
              </div>
              {showDialogs ?
  <HardDelete
    {...deletingProps} 
    showResult={(e) => {
      console.log(e);
      
      setTimeout(() => {
        let storeData = [...dataSourceState[Id]];
        console.log(deletingProps);

        const indexToDelete = storeData.findIndex(
          row => row.IdentityField === deletingProps.IdentityField
        );

        if (indexToDelete !== -1) {
          storeData.splice(indexToDelete, 1);
          saveData(storeData);
          grids.current[Id].refresh();
        } else {
          console.log("Row with IdentityField not found");
          getListService(true);
        }

        setShowDialogs(false);

        ToolbarClicking(
          grids.current[Id],
          { name: "DeletedCompleted" },
          selectedRows.length === 0 ? undefined : selectedRows,
          getListService,
          saveData,
          storeData // Now defined here correctly
        );

        if (e === false) {
          // Handle failure if needed
        }

      }, 200);
    }} 
  />
: null}

               {
            loadingdataSourceState == false ?  
              <ListGridComponent />
              :                 
              <div className='loader-div'> <img src={imgSrc} id='' /> LOADING...</div>
            } 
            </div>
          </div>
          </div>
  );
}





